// extracted by mini-css-extract-plugin
export var content = "_a8-3";
export var list = "_a8-4";
export var settingsContent = "_a8-7";
export var settingsPanel = "_a8-8";
export var state = "_a8-6";
export var triggerBadge = "_a8-2";
export var triggerButton = "_a8-1";
export var triggerShell = "_a8-0";
export var unreadDot = "_a8-5";